export default "__VITE_ASSET__DGpR2FIp__"